import React from "react";
import ChatIcon from "./icon";
import ChatBotBody from "./body";
// import "./style.css";

export const ChatBot = () => {
  return (
    <>
      <ChatIcon />
      <ChatBotBody />
    </>
  );
};

export default ChatBot;
